module.exports = __webpack_public_path__ + "img/check.836918fc.png";